<div class="manage-blk" fxLayout="row wrap" fxLayoutAlign="start stretch">
<button mat-icon-button *ngFor="let icon of data" [matTooltip]="icon?.toolTip" [disabled]="icon?.disabled" #actionBtn
	(click)="manageInfo({'actionElement': actionBtn, 'data': icon})" class="manage-btn" [ngClass]="icon?.classes">
	<ng-container *ngIf="icon?.svgIcon">
		<mat-icon [svgIcon]="icon?.svgIcon">{{icon?.icon}}</mat-icon>
	</ng-container>
	<ng-container *ngIf="!icon?.svgIcon && icon?.icon">
		<mat-icon>{{icon?.icon}}</mat-icon>
	</ng-container>
</button>
</div>
